<template>
  <div>
    <div class="container border-bottom">
        <div class="col-lg-12 row justify-space-between py-2 container border-bottom">
          <div class="col-lg-5 me-auto">
            <h3 class="lead text-dark pt-1 bold mb-1">{{ article.title }}</h3>
            <small>{{article.description}}</small>
          </div>
          <v-btn
              outlined
              class="font-weight-bolder secondary py-4 px-5 mb-6"
              small
          >
            SEND FEEDBACK
          </v-btn>
        </div>
      <div>
        <embed :src= "fileLink + '#toolbar=0&navpanes=0&scrollbar=0'" type="application/pdf"
               width="100%"
               height="900">
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import {mapState} from "vuex";

export default {
  name: "Returns-List",
  data: function () {
    return {
      article: '',
      fileLink: '',
    };
  },
  computed: {
    ...mapState(['base_url']),
  },
  created () {
    this.getDocument()
  },
  methods: {
    goToRead(item) {
      this.$router.push({
        name: "Read",
        params: {id: item.id},
        query: {id: item.id,},
      });
    },
    async getDocument() {
      const JWTToken = this.$store.getters.accessToken
      axios.get(this.base_url + '/circular/view-circular/' + this.$route.query.id)
          .then(res => {
            if (res.status === 200) {
              this.article = res.data[0]
              let image = this.article.file
              console.log(image,"before fileLink")
              let newLi = this.base_url + '' + image
              this.fileLink = String(newLi)
              console.log(this.fileLink,"fileLink")
            } else if (res.status === 202) {
              console.log('202')
            } else {
              console.log('error')
            }
          })
    },
  }
  }
</script>
